import { useQuery } from "react-query";
import { getSubEntities, getSubEntitiesByIdEntity } from "../../services/scientific/subEntity";
import { PagedRequestType } from "../../types/PagedResults";
import { SUBENTITIES, Key_subEntities, GET_PROJECT_IN_JUDGE_PHASE_PROJECTS_BY_ID_JUDGE } from "../../utils/constants";


export const useGetSubEntitiesQuery = (data: PagedRequestType) =>
  useQuery(
    [Key_subEntities, JSON.stringify(data)],
    () => getSubEntities(data)
  );

  export const useGetSubEntitiesByIdEntity = (data: PagedRequestType, options:any= null) =>
    useQuery(
      [Key_subEntities, JSON.stringify(data)],
      () => getSubEntitiesByIdEntity(data),
      options?{...options}:{}
    );